<template>
  <div>
    <h3>我是 B 网页</h3>
    <h4>{{ random }}</h4>
  </div>
</template>

<script>
  export default {
    name: 'page-b'
  };
</script>

<style lang="scss" scoped>

</style>